import BlockTypes from '../../../types/BlockTypes';

function isInCodeBlock(value) {
  var document = value.document,
      selection = value.selection;
  var startKey = selection.anchor.key;
  var codeBlock = document.getClosest(startKey, function findCodeBlock(block) {
    return block.type === BlockTypes.CODES;
  });
  return Boolean(codeBlock);
}

export default isInCodeBlock;